module.exports = __webpack_public_path__ + "static/media/no-internet-orange-48x48.50706f74.svg";